import { forwardRef } from 'react';
import { cn } from '@/lib/utils.js';

const Input = forwardRef(function Input({ className, type = 'text', ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex min-h-[44px] w-full rounded-card border border-border bg-bg px-3 py-2 text-sm text-text',
        'placeholder:text-text-dim',
        'focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-1 focus:ring-offset-bg',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className
      )}
      {...props}
    />
  );
});

export { Input };
